import React from 'react'
import Translation from '../../Translation/cont/Translation'
import decodeHtml from '../../../functions/decodeHtml'


const ActorDirectorInfo = ({directors, actors, translation}) => {
    if (!directors) {
        return ''
    }

    const filteredActors = _.filter(actors, actor => {
        return actor.name !== null
    })

    let actorsArr = filteredActors.length > 3 ? filteredActors.slice(0, 3) : filteredActors 
    let directorsElem
    let actorsElem = ''
    
    if(directors.length === 1) {
        directorsElem = decodeHtml(directors[0].name)
    } else if(directors.length === 2) {
        directorsElem = <Translation id="and" trans={translation} before={decodeHtml(directors[0].name) + ' '} after={' ' + decodeHtml(directors[1].name)}>und</Translation>
    } 

    actorsArr.map((actor, index) => {
        const before = actorsArr.length !== 1 ? index === (actorsArr.length - 1) ? ' und ' : index !== 0 ? ', ' : '' : ''
        actorsElem += before + actor.name 
    })

    return (
        <>
            {directorsElem && <div><Translation id="director" trans={translation}>Regisseur:in</Translation>: {directorsElem}</div>}
            {actorsElem && <div><Translation id="with" trans={translation}>Mit</Translation>: {actorsElem}</div>}
        </>
    )
}

export default ActorDirectorInfo